export default __webpack_public_path__ + "static/media/team_adam_zoomed.c0a014ad.png";